// Auto-split from i18n.js — language: ru
export default {
    translation: {
        // routes & menus
        Dashboard: 'Щиток',
        'Space Data': 'Пространство',
        'Equipment Data': 'Оборудование',
        'Meter Data': 'Метр',
        'Tenant Data': 'Съёмщик',
        'Store Data': 'Магазин',
        'Shopfloor Data': 'Торговый зал',
        'Combined Equipment Data': 'Комбинированное оборудование',
        'Auxiliary System': 'Вспомогательная система',
        Microgrid: 'Микросеть',
        'Energy Storage Power Station': 'Электростанция',
        'Photovoltaic Power Station': 'Электростанция',
        'Fault Alarm': 'Сигнализация неисправности',
        Monitoring: 'Контроль',
        'Advanced Reporting': 'Расширенная отчетность',
        'Knowledge Base': 'База знаний',
        'Energy Category Data': 'Категория «Энергия»',
        'Energy Item Data': 'Энергетический элемент',
        Carbon: 'Выбросы CO2',
        Cost: 'Стоить',
        Output: 'Выпуск',
        Income: 'Доход',
        Efficiency: 'Эффективность',
        Load: 'Груз',
        Statistics: 'Статистика',
        'Batch Analysis': 'Пакетный анализ',
        Saving: 'СпасительныйⒺ',
        Plan: 'ПланⒺ',
        Prediction: 'PredictionⒺ',
        'Production': 'Production',
        'Space Production': 'Space Production',
        'Equipment Tracking': 'Отслеживание оборудования',
        'Equipment Comparison': 'Сравнение оборудования',
        'Shopfloor Comparison': 'Сравнение оборудования',
        'Store Comparison': 'Сравнение оборудования',
        'Space Comparison': 'Сравнение оборудования',
        'Combined Equipment Comparison': 'Сравнение оборудования',
        'Tenant Comparison': 'сравнение арендаторов',
        'Environment Monitor': 'Монитор окружающей среды',
        'Meter Energy': 'Счетчик энергии',
        'Meter Prediction': 'Прогноз счетчикаⒺ',
        'Virtual Meter Prediction': 'Прогноз виртуального счетчикаⒺ',
        'Offline Meter Prediction': 'Прогноз офлайн-счетчикаⒺ',
        'Meter Carbon': 'Выбросы CO2 по приборам',
        'Meter Cost': 'Стоимость счетчика',
        'Meter Trend': 'Тренд счетчика',
        'Meter Realtime': 'Счетчик в реальном времени',
        'Meter Saving': 'Экономия счетчиковⒺ',
        'Meter Plan': 'Метрический планⒺ',
        'Master Meter Submeters Balance': 'Весы счетчиков Master Meter',
        'Meter Batch Analysis': 'Пакетный анализ счетчиков',
        'Meter Comparison': 'Сравнение счетчиков',
        'Meter Tracking': 'Слежение за счетчиком',
        'Virtual Meter Saving': 'Экономия виртуальных счетчиковⒺ',
        'Virtual Meter Plan': 'План виртуального счетчикаⒺ',
        'Virtual Meter Energy': 'Виртуальный счетчик энергии',
        'Virtual Meter Carbon': 'Выбросы CO2 виртуальными приборами',
        'Virtual Meter Cost': 'Стоимость виртуального счетчика',
        'Virtual Meter Batch Analysis': 'Анализ партии виртуальных счетчиков',
        'Virtual Meter Comparison': "Сравнение виртуальных счетчиков",
        'Offline Meter Energy': 'Автономный счетчик энергии',
        'Offline Meter Carbon': 'Выбросы CO2 из автономных приборов',
        'Offline Meter Cost': 'Стоимость автономного счетчика',
        'Offline Meter Batch Analysis': 'Автономный пакетный анализ счетчиков',
        'Offline Meter Saving': 'Автономное сохранение счетчиковⒺ',
        'Offline Meter Plan': 'План автономного счетчикаⒺ',
        'Offline Meter Input': 'Автономный вход счетчика',
        'Tenant Bill': 'Счет арендатора',
        'Energy Flow Diagram': 'Диаграмма потоков энергии',
        'Distribution System': 'Система дистрибуции',
        'SVG System': 'Система визуализации SCADA',
        'Faults Data': 'Ошибки',
        'Space Equipments': 'Космическое оборудование',
        'Combined Equipments': 'Комбинированное оборудование',
        'Energy Storage Power Station List': 'List',
        'Energy Storage Power Station Details': 'Details',
        'Energy Storage Power Station Reporting': 'Reporting',
        'Energy Storage Power Station Alarm': 'Alarm',
        'Energy Storage Power Station Maintenance': 'Maintenance',
        'Enter Production': 'Enter Production',
        'Multiple Microgrids': 'Multiple Microgirds',
        'Multiple Microgrids Dashboard': 'Dashboard',
        'Multiple Microgrids List': 'List',
        'Single Microgrid': 'Single Microgrid',
        'Single Microgrid Dashboard': 'Dashboard',
        'Single Microgrid Details': 'Details',
        'Single Microgrid Fault Alarm': 'Fault Alarm',
        'Microgrid Reports': 'Power Station Reports',
        'Microgrid Reports Energy': 'Energy',
        'Microgrid Reports Revenue': 'Revenue',
        'Microgrid Reports Parameters': 'Parameters',
        'Multiple Energy Storage Power Stations': 'Multiple Power Stations',
        'Multiple Energy Storage Power Stations Dashboard': 'Dashboard',
        'Multiple Energy Storage Power Stations List': 'List',
        'Single Energy Storage Power Station': 'Single Power Station',
        'Single Energy Storage Power Station Dashboard': 'Dashboard',
        'Single Energy Storage Power Station Details': 'Details',
        'Single Energy Storage Power Station Fault Alarm': 'Fault Alarm',
        'Energy Storage Power Station Reports': 'Power Station Reports',
        'Energy Storage Power Station Reports Energy': 'Energy',
        'Energy Storage Power Station Reports Revenue': 'Revenue',
        'Energy Storage Power Station Reports Parameters': 'Parameters',
        'Photovoltaic Power Station List': 'Power Station List',
        'Photovoltaic Power Station Details': 'Details',
        'Photovoltaic Power Station Reporting': 'Reporting',
        'Photovoltaic Power Station Alarm': 'Alarm',
        'Photovoltaic Power Station Maintenance': 'Maintenance',
        'Multiple Photovoltaic Power Stations': 'Multiple Power Stations',
        'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard',
        'Multiple Photovoltaic Power Stations List': 'List',
        'Single Photovoltaic Power Station': 'Single Power Station',
        'Single Photovoltaic Power Station Dashboard': 'Dashboard',
        'Single Photovoltaic Power Station Details': 'Details',
        'Single Photovoltaic Power Station Fault Alarm': 'Fault Alarm',
        'Photovoltaic Power Station Reports': 'Power Station Reports',
        'Photovoltaic Power Station Reports Energy': 'Energy',
        'Photovoltaic Power Station Reports Revenue': 'Revenue',
        'Photovoltaic Power Station Reports Parameters': 'Parameters',
        'Work Order': 'Work Order',
        'Work Order Installation': 'Installation',
        'Work Order Repair': ' Repair',
        'Work Order Inspection': 'Inspection',
        'Total Number of Work Orders': 'Общее количество заказов на работу',
        'Number of New Work Orders': 'Количество новых заказов на работу',
        'Number of Inprogress Work Orders': 'Количество незавершенных заказов на работу',
        'Number of Done Work Orders': 'Количество выполненных заказов на работу',
        'Fuel Indicator': 'Потребление топлива',
        'Charge Energy Indicator': 'Зарядка энергии',
        'Discharge Energy Indicator': 'Разрядка энергии',
        'Charge Cost Indicator': 'Стоимость зарядки',
        'Discharge Revenue Indicator': 'Доход от разрядки',
        'HVAC': 'HVAC',
        'Fire Control': 'Пожарная безопасность',
        'Store Dashboard': 'Панель Магазинов',
        'Comprehensive overview of store energy performance': 'Комплексный обзор энергоэффективности магазинов',
        'Total Stores': 'Всего Магазинов',
        'Total Area': 'Общая Площадь',
        'Active Meters': 'Активные Счетчики',
        'Active Alerts': 'Активные Оповещения',
        'Total Energy Consumption': 'Общее Потребление Энергии',
        'Carbon Emissions': 'Выбросы Углерода',
        'Current Period': 'Текущий Период',
        'Energy Consumption by Category': 'Потребление Энергии по Категориям',
        'Cost Distribution by Category': 'Распределение Затрат по Категориям',
        'Monthly Energy & Cost Trends': 'Месячные Тренды Энергии и Затрат',
        'Top 5 Energy Consuming Stores': 'Топ-5 Магазинов по Потреблению Энергии',
        'Energy Category Details': 'Детали Категорий Энергии',
        'Store Performance Overview': 'Обзор Эффективности Магазинов',
        'YoY Change': 'Изменение за Год',
        'Per m²': 'На м²',
        'Usage Intensity': 'Интенсивность Использования',
        'Dashboard data loaded successfully': 'Данные панели успешно загружены',
        'Failed to load dashboard data': 'Не удалось загрузить данные панели',
        'Store Name': 'Название магазина',
        'Store Area': 'Площадь магазина',
        'Energy Consumption': 'Потребление энергии',
        'Consumption': 'Потребление',
        'last period': 'прошлый период',
        // Tenant Dashboard
        'Tenant Dashboard': 'Панель Арендаторов',
        'Comprehensive overview of tenant energy performance': 'Комплексный обзор энергоэффективности арендаторов',
        'Total Tenants': 'Всего Арендаторов',
        'Tenant Performance Overview': 'Обзор Эффективности Арендаторов',
        'Tenant Name': 'Название Арендатора',
        'Tenant Area': 'Площадь Арендатора',
        'Tenant Type': 'Тип Арендатора',
        // Equipment Dashboard
        'Equipment Dashboard': 'Панель оборудования',
        'Total Equipments': 'Всего оборудования',
        'Equipment Performance Overview': 'Обзор производительности оборудования',
        'Equipment Name': 'Название оборудования',
        'Equipment Type': 'Тип оборудования',
        'Total Energy': 'Общая энергия',
        'Total Sensors': 'Всего датчиков',
        'Increment Rate': 'Темп роста',
        // Shopfloor Dashboard
        'Total Shopfloors': 'Общее количество цехов',
        'Shopfloor Performance Overview': 'Обзор производительности цехов',
        'Shopfloor Name': 'Название цеха',
        'Shopfloor Area': 'Площадь цеха',
        // Combined Equipment Dashboard
        'Total Combined Equipments': 'Общее количество комбинированного оборудования',
        'Combined Equipment Performance Overview': 'Обзор производительности комбинированного оборудования',
        'Combined Equipment Name': 'Название комбинированного оборудования',
        'Associated Equipments': 'Связанное оборудование',

            // Dashboard
            'Welcome to QiXuan': 'Добро пожаловать в QiXuan',
            'An Industry Leading Energy Management System':
                'Ведущая в отрасли система управления энергопотреблением',
            "This Year's Consumption CATEGORY VALUE UNIT": 'В этом году Consumption {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Year's Costs CATEGORY VALUE UNIT": 'Расходы этого года {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Consumption CATEGORY VALUE UNIT": 'Потребление в этом месяце {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Month's Costs CATEGORY VALUE UNIT": 'Расходы за этот месяц {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
                'Потребление {{CATEGORY}} {{VALUE}} {{UNIT}} за аналогичный период прошлого года',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
                'Издержки {{CATEGORY}} {{VALUE}} {{UNIT}} за аналогичный период прошлого года',
            'CATEGORY Consumption UNIT': '{{CATEGORY}} Потребление {{UNIT}}',
            'CATEGORY Costs UNIT': '{{CATEGORY}} Издержки {{UNIT}}',
            // Entities
            Space: 'Пространство',
            Equipment: 'Оборудование',
            Meter: 'Метр',
            'Offline Meter': 'Автономный счетчик',
            'Virtual Meter': 'Виртуальный счетчик',
            Tenant: 'Съёмщик',
            Store: 'Магазин',
            Shopfloor: 'Торговый зал',
            'Combined Equipment': 'Комбинированное оборудование',
            'Cost Center': 'Центр затрат',
            Name: 'Имя',
            DisplayName: 'Отображаемое имя',
            UserName: 'Имя пользователя',
            Description: 'Описание',
            'Energy Category': 'Категория «Энергия»',
            'Child Spaces': 'Детские пространства',
            'Associated Equipment': 'Сопутствующее оборудование',
            //Energy Categories
            Electricity: 'Электричество',
            Water: 'Вода',
            'Natural Gas': 'Природный газ',
            // SidePanelModal
            Settings: 'Параметры',
            'Set your own customized style': 'Установите свой собственный стиль',
            'Color Scheme': 'Цветовая схема',
            'Choose the perfect color mode for your app': 'Выберите идеальный цветовой режим для вашего приложения',
            Light: 'Свет',
            Dark: 'Темный',
            'RTL Mode': 'Режим RTL',
            'Switch your language direction': 'Переключение языкового направления',
            'Fluid Layout': 'Плавная компоновка',
            'Toggle container layout system': 'Переключить систему компоновки контейнеров',
            'Navigation Position': 'Навигационное положение',
            'Vertical': 'Вертикально',
            'Top': 'Верхний',
            'Combo': 'Комбинация',
            'Transparent': 'Прозрачный',
            'Inverted': 'Перевёрнутый',
            'Card': 'Карточный',
            'Vibrant': 'Живой',
            'Select a suitable navigation system for your web application':
                'Выберите подходящую навигационную систему для вашего веб-приложения',
            'Vertical Nav': 'Вертикальная навигация',
            'Top Nav': 'Наверх Навигатор',
            'Vertical Navbar Style': 'Вертикальный стиль навигационной панели',
            'Switch between styles for your vertical navbar': 'Переключение между стилями для вертикальной панели навигации',
            Language: 'Язык',
            'Switch between languages': 'Переключение между языками',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Русский',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ภาษาไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中文',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': 'Нравится то, что вы видите?',
            'Get QiXuan now': 'Получить QiXuan прямо сейчас',
            Purchase: 'Корпоративная версия',
            ContactInfo: 'Контактная информация',
            ProductWebsite: 'Сайт продукта',
            CompanyWebsite: 'Сайт компании',
            SalesPhone: 'Телефон отдела продаж',
            // Query Panel
            'Base Period Begins': 'Начинается базовый период',
            'Base Period Ends': 'Базовый период заканчивается',
            'Comparison Types': 'Типы сравнения',
            'Year-Over-Year': 'Год к году',
            'Month-On-Month': 'Месяц за месяцем',
            'Free Comparison': 'Бесплатное сравнение',
            'None Comparison': 'Нет сравнения',
            'Reporting Period Begins': 'Начало отчетного периода',
            'Reporting Period Ends': 'Окончание отчетного периода',
            '(Optional)': '(Необязательный)',
            'Period Types': 'Типы периодов',
            Yearly: 'Ежегодный',
            Monthly: 'Ежемесячный',
            Weekly: 'Еженедельный',
            Daily: 'Ежедневный',
            Hourly: 'Ежечасный',
            Submit: 'Отправить',
            'Input Energy Category': 'Категория входной энергии',
            'Output Energy Category': 'Категория выходной энергии',
            'Fraction Parameter': 'Параметр фракции',
            Search: 'Искать',
            //DateRangePicker
            sunday: 'Su',
            monday: 'Mo',
            tuesday: 'Tu',
            wednesday: 'We',
            thursday: 'Th',
            friday: 'Fr',
            saturday: 'Sa',
            ok: 'ХОРОШО',
            today: 'Сегодня',
            yesterday: 'Вчера',
            hours: 'Часов',
            minutes: 'Протокол',
            seconds: 'Товары второго сорта',
            last7Days: 'Последние 7 дней',
            tomorrow: 'Завтра',
            dayAfterTomorrow: 'Послезавтра',
            next7Days: 'Следующие 7 дней',
            'Select Date Range': 'Выберите диапазон дат',
            //Card Summaries and Line Charts
            'Base Period': 'Базовый период',
            'Reporting Period': 'Отчетный период',
            'Per Unit Area': 'На единицу площади',
            'Per Capita': 'Per Capita',
            'Per Unit Production': 'На единицу продукции',
            Baseline: 'Базис',
            Actual: 'Действительный',
            'Baseline Value - Actual Value': 'Базовый уровень - Фактический',
            'Average Load': 'Средняя нагрузка',
            'Maximum Load': 'Максимальная нагрузка',
            'Load Factor': 'Коэффициент загрузки',
            'Ratio of Average Load to Maximum Load': 'Отношение средней нагрузки к максимальной нагрузке',
            'Carbon Dioxide Emissions by Energy Category': 'Выбросы углекислого газа по энергетическим категориям',
            'Costs by Energy Category': 'Затраты по энергетическим категориям',
            'Incomes by Energy Category': 'Доходы по энергетическим категориям',
            'Electricity Consumption by Time-Of-Use': 'Потребление электроэнергии по времени использования',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use':
                'Выбросы углекислого газа в электроэнергетике по времени использования',
            'Electricity Cost by Time-Of-Use': 'Стоимость электроэнергии по времени использования',
            'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} Потребление по энергетическим объектам',
            'Ton of Standard Coal by Energy Category': 'Тонна стандартного угля (ТВК) по энергетическим категориям',
            'Ton of Carbon Dioxide Emissions by Energy Category':
                'Тонн выбросов углекислого газа (TCO2E) по энергетическим категориям',
            'Reporting Period Consumption CATEGORY UNIT': 'Потребление за отчетный период {{CATEGORY}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{EQUIPMENT}} Потребление за отчетный период {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Потребление за отчетный период{{CATEGORY}} {{UNIT}}',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption CATEGORY VALUE UNIT': 'Потребление за отчетный период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': 'Reporting Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Production PRODUCT VALUE UNIT': 'Base Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption CATEGORY VALUE UNIT': 'Потребление за базовый период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY UNIT':
                'Потребление за отчетный период {{ITEM}} {{CATEGORY}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
                'Потребление за отчетный период {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT':
                'Потребление за базовый период {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Child Space Proportion CATEGORY UNIT':
                'Доля дочернего пространства по энергетическим категориям {{CATEGORY}} {{UNIT}}',
            'Child Space Total Proportion': 'Общая доля дочернего пространства',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
                'Выбросы двуокиси углерода за отчетный период {{CATEGORY}} {{UNIT}}',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Выбросы двуокиси углерода за отчетный период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Выбросы углекислого газа за базовый период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Costs CATEGORY UNIT': 'Затраты за отчетный период {{CATEGORY}} {{UNIT}}',
            'Reporting Period Costs CATEGORY VALUE UNIT': 'Затраты за отчетный период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Costs CATEGORY VALUE UNIT': 'Затраты на базовый период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Output CATEGORY UNIT': 'Результаты работы за отчетный период {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{EQUIPMENT}} Результаты работы за отчетный период {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Результаты работы за отчетный период {{CATEGORY}} {{UNIT}}',
            'Reporting Period Output CATEGORY VALUE UNIT':
                'Результаты работы за отчетный период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Output CATEGORY VALUE UNIT': 'Выходные данные за базовый период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Income CATEGORY UNIT': 'Доходы за отчетный период {{CATEGORY}} {{UNIT}}',
            'Reporting Period Income CATEGORY VALUE UNIT': 'Доходы за отчетный период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Income CATEGORY VALUE UNIT': 'Доход за базовый период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Total Income UNIT': 'Совокупный доход за отчетный период {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT':
                'Совокупная эффективность отчетного периода {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
                '{{EQUIPMENT}} Совокупная эффективность отчетного периода {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Совокупная комплексная эффективность отчетного периода {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Совокупная комплексная эффективность отчетного периода {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Базисный период Кумулятивная комплексная эффективность {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': 'Мгновенная эффективность {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} Мгновенная эффективность {{UNIT}}',
            'Equipment Efficiency Indicator': 'Показатель энергоэффективности оборудования',
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Мгновенная комплексная эффективность {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT':
                'Совокупная эффективность отчетного периода {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
                'Совокупная эффективность отчетного периода {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': 'Кумулятивная эффективность базисного периода {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT':
                'Кумулятивная эффективность базисного периода {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': 'Базовый период {{CATEGORY}} Максимальная нагрузка {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': 'Отчетный период {{CATEGORY}} Максимальная нагрузка {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT': 'Отчетный период {{CATEGORY}} Средняя нагрузка {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': 'Отчетный период {{CATEGORY}} Коэффициент загрузки',
            'Base Period CATEGORY Average Load VALUE UNIT': 'Базовый период {{CATEGORY}} Средняя нагрузка {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': 'Отчетный период {{CATEGORY}} Среднее значение {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': 'Отчетный период {{CATEGORY}} Максимальное значение {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': 'Отчетный период {{CATEGORY}} Минимальное значение {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': 'Отчетный период {{CATEGORY}} Среднее арифметическое {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT': 'Отчетный период {{CATEGORY}} Медиана (Среднее значение) {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': 'Отчетный период {{CATEGORY}} Стандартное отклонение образца {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': 'Отчетный период {{CATEGORY}} Дисперсия выборки {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
                'Сохранение отчетного периода {{CATEGORY}} (Базовый уровень - Фактический) {{UNIT}}',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
                'Отчетный период сократился {{CATEGORY}} (Базовый уровень - Фактический) {{UNIT}}',
            'Reporting Period Saving CATEGORY VALUE UNIT': 'Сохранение отчетного периода {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Saving CATEGORY VALUE UNIT': 'Экономия за базовый период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY UNIT':
                'Потребление эталонного счетчика за отчетный период {{CATEGORY}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
                'Потребление эталонного счетчика за отчетный период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY UNIT':
                'Потребление субсчетчиков за отчетный период {{CATEGORY}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
                'Потребление субсчетчиков за отчетный период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Difference CATEGORY UNIT': 'Разница в отчетных периодах {{CATEGORY}} {{UNIT}}',
            'Reporting Period Percentage Difference': 'Разница в процентах за отчетный период',
            'Reporting Period Difference CATEGORY VALUE UNIT': 'Разница в отчетных периодах {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Trend Values': 'Значения тренда',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': 'Список неисправностей',
            'Reporting Period Number of Fault VALUE': 'Номер неисправности за отчетный период {{VALUE}}',
            'All Faults': 'Все неисправности',
            'Space Faults': 'Космические разломы',
            'Number of All Faults': 'Количество всех неисправностей',
            'Number of Space Faults': 'Количество пробелов',
            'Total Number of Faults': 'Total Number of Faults',
            'Number of New Faults': 'Number of New Faults',
            'Number of Inprogress Faults': 'Number of Inprogress Faults',
            'Number of Done Faults': 'Number of Done Faults',
            //Data Panels
            'Ton of Standard Coal': 'Тонна стандартного угля',
            'Ton of Carbon Dioxide Emissions': 'тонн выбросов углекислого газа',
            'Carbon Emissions Per Unit Of Energy Consumption': 'Выбросы углерода на единицу потребления энергии',
            'Operating Characteristic Curve': 'рабочая характеристика',
            Tariff: 'Тариф',
            'Detailed Data': 'Подробные данные',
            'Child Spaces Data': 'Данные о дочерних пространствах',
            'Associated Equipment Data': 'Связанные данные об оборудовании',
            'This Year': 'В этом году',
            'The Same Period Last Year': 'Аналогичный период прошлого года',
            'This Month': 'В этом месяце',
            'This Day': 'Сегодня',
            Total: 'Итог',
            'No data found': 'Данные не найдены',
            Export: 'Экспорт',
            'AI Analysis': 'ИИ-анализ',
            Datetime: 'Дата и время',
            'Time-Of-Use Type': 'Тип времени использования',
            'Top-Peak': 'Топ-Пик',
            'On-Peak': 'На пике',
            'Mid-Peak': 'Мид-Пик',
            'Off-Peak': 'Вне пика',
            'Deep': 'Deep-Valley',
            Percentage: 'Процент',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': 'Тренд в последний час Energy Value Point',
            Circuit: 'Контур',
            Point: 'Точка',
            'Realtime Value': 'Значение в реальном времени',
            //Meter Tracking
            'Meter List': 'Список счетчиков',
            'Edit Meter': 'Редактировать',
            'Start Value': 'Начальное значение',
            'End Value': 'Конечная стоимость',
            'Difference Value': 'Значение разницы',
            'Start Integrity Rate': 'Начальный уровень целостности(%)',
            'End Integrity Rate': 'Конечная степень целостности(%)',
            'Full Integrity Rate': 'Полная степень целостности(%)',
            'Start Integrity Rate Description': 'Коэффициент целостности начальных данных: Доля приборов, успешно получивших показания потребления энергии в момент начала, среди всех приборов за статистический период',
            'End Integrity Rate Description': 'Коэффициент целостности конечных данных: Доля приборов, успешно получивших показания потребления энергии в момент окончания, среди всех приборов за статистический период',
            'Full Integrity Rate Description': 'Коэффициент полной целостности данных: Доля приборов, успешно получивших показания потребления энергии как в момент начала, так и в момент окончания, среди всех приборов за статистический период',
            //Equipment Tracking
            'Equipment List': 'Список оборудования',
            'Edit Equipment': 'Редактировать',
            //Profile Dropdown
            Feedback: 'Обратная связь',
            'Account Settings': 'Настройки учетной записи',
            Logout: 'Выход',
            //Authentication
            'Log in': 'Войти',
            'Email address': 'Адрес электронной почты',
            'Phone Number': 'Номер телефона',
            Password: 'Пароль',
            CaptchaCode: 'Капча',
            Refresh: 'Освежать',
            'Remember me': 'Помни обо мне',
            'Logged in as ': 'Авторизовался как ',
            'Forgot Password?': 'Забыли пароль?',
            'Forgot your password?': 'Забыли пароль?',
            "Enter your email and we'll send you a reset link":
                'Введите свой адрес электронной почты, и мы вышлем вам ссылку для сброса',
            "Enter your email and we'll send you a registration link":
                'Введите свой адрес электронной почты, и мы вышлем вам ссылку для регистрации',
            'Reset Password': 'Сброс пароля',
            'Thanks for using QiXuan!': 'Спасибо за использование QiXuan!',
            'You are now successfully signed out': 'Теперь вы успешно вышли из системы',
            'Return to Login': 'Вернуться к входу в систему',
            'Please check your email!': 'Пожалуйста, проверьте свою электронную почту!',
            'An email has been sent to ': 'Электронное письмо было отправлено по адресу ',
            'Please click on the included link to reset your password':
                'Пожалуйста, нажмите на прилагаемую ссылку, чтобы сбросить пароль',
            'Please click on the included link to register your account':
                'Пожалуйста, нажмите на прилагаемую ссылку, чтобы зарегистрировать свою учетную запись',
            'An email with password reset link is sent to ':
                'Электронное письмо со ссылкой для сброса пароля отправляется на адрес ',
            'Change Password': 'Смена пароля',
            'Old Password': 'Старый пароль',
            'New Password': 'Новый пароль',
            'Confirm Password': 'Подтвердите пароль',
            'Update Password': 'Обновить пароль',
            'Password has been changed!': 'Пароль был изменен!',
            'Verification code has been sent to your inbox. \
      Please copy it to the input box below..':
                'Код подтверждения был отправлен на ваш почтовый ящик. \
      Скопируйте его в поле ввода ниже.',
            'New to QiXuan': 'Новичок в QiXuan',
            'Create an account': 'Создать аккаунт',
            'EMAIL Account registration successful': '{{EMAIL}} Регистрация аккаунта прошла успешно',
            'Thanks for verifying your account!': 'Спасибо за подтверждение вашей учетной записи!',
            'Your code is': 'Ваш код:',
            'Send verification code': 'Отправить проверочный код',
            'Please wait for NUMBER seconds': 'Пожалуйста, подождите {{NUMBER}} товары второго сорта',
            'Password reset': 'Сброс пароля',
            'Please wait for approval': 'Пожалуйста, дождитесь одобрения',
            //notification
            Notifications: 'Уведомления',
            'Mark all as read': 'Пометить все как прочитанное',
            'View all': 'Bce',
            'Notification New': 'Новые функции',
            'Notification Earlier': 'РАНЬШЕ',
            'Notification List': 'Список уведомлений',
            'Bulk actions': 'Массовые действия',
            'Notification Subject': 'Тема',
            'Notification Created Datetime': 'Дата и время создания',
            'Notification Priority': 'Приоритет',
            'Notification Message': 'Сообщение',
            'Notification Status': 'Статус',
            'Notification Mark As Read': 'Отметить как прочитанное',
            'Notification Mark As Acknowledged': 'Признавать',
            'Notification Low': 'Низкий',
            'Notification Medium': 'Терпимая',
            'Notification High': 'Высокий',
            'Notification Critical': 'Критический',
            'Notification Unread': 'Непрочитанный',
            'Notification Read': 'Читать',
            'Notification Acknowledged': 'Признанный',
            'Notification Archive': 'Архив',
            'Notification Delete': 'Удалить',
            'Notification Apply': 'Применять',
            'Notification Start Datetime': 'Дата и время начала',
            'Notification End Datetime': 'Конец даты и времени',
            'Notification Update Datetime': 'Обновить дату и время',
            //Monitoring
            'Run Commands': 'Выполнение команд',
            'Pin Code': 'Пин-код',
            'Unlock': 'Разблокировать',
            'Set Value': 'Установить значение',
            'Fault Alarms': 'Аварийные сигналы о неисправностях',
            'Instantaneous Efficiency VALUE UNIT': 'Мгновенная эффективность {{VALUE}} {{UNIT}}',
            'Communication Online': 'Онлайн',
            'Communication Offline': 'Автономный',
            'Equipment Status': 'Состояние оборудования',
            'Equipment Running': 'Бег',
            'Equipment Stopped': 'Остановленный',
            'Show Up to': 'Показать до',
            All: 'Все',
            'FROM - TO of TOTAL': '{{FROM}} - {{TO}} из {{TOTAL}} Оборудования',
            //Microgrid
            'Microgrid Energy': 'Микросетевая энергетика',
            'Microgrid Revenue': 'Доход от микросетей',
            'Microgrid Carbon': 'Углерод от микросетей',
            'Photovoltaic Generation': 'Фотоэлектрическая генерация',
            'EV Charger Consumption': 'Потребление зарядных устройств EV',
            'Load Consumption': 'Потребление нагрузки',
            'Grid Buy': 'Покупка из сети',
            'Grid Sell': 'Продажа в сеть',
            'EV Charger': 'Зарядное устройство для электромобилей',
            'Heat Pump': 'Тепловой насос',
            'Photovoltaic': 'Фотоэлектрические',
            'PCS Run State': 'Режим работы PCS',
            'PCS Unknown': 'Неизвестный',
            'PCS Initializing': 'Начинается',
            'PCS Standby': 'Запасные материалы',
            'PCS Shutdown': 'Остановка',
            'PCS Fault': 'Ошибка',
            'PCS Running': 'Бег',
            'Battery Power': 'Мощность батареи',
            'Photovoltaic Power': 'Фотоэлектрическая мощность',
            'Grid Power': 'Мощность сети',
            'Load Power': 'мощность нагрузки',
            Reporting: 'Доклады',
            Maintenance: 'Техническое обслуживание',
            'Serial Number': 'Серийный номер',
            Address: 'Адрес',
            'Postal Code': 'Почтовый индекс',
            'Rated Capacity': 'Номинальная емкость',
            'Rated Power': 'Номинальная мощность',
            Latitude: 'Широта',
            Longitude: 'Долгота',
            'Strategy Management': 'Стратегическое управление',
            'Charging Schedule': 'График зарядки',
            'Charge Start Time': 'Время начала зарядки',
            'Charge End Time': 'Время окончания зарядки',
            'Discharge Start Time': 'Время начала разряда',
            'Discharge End Time': 'Время окончания разряда',
            'Total Rated Power': 'Общая номинальная мощность',
            'Total Rated Capacity': 'Общая номинальная мощность',
            "Today's Charge": "Сегодняшняя сумма начисления",
            "Today's Discharge": "Выписка сегодня",
            "Today's Generation": "Современная энергетика",
            'Total Fuel Consumption': 'Total Fuel Consumption',
            'Total Charge': 'Полный заряд',
            'Total Discharge': 'общий сброс',
            'Total Generation': 'Общая генерация',
            'Total Revenue': 'Общий доход',
            'Total Photovoltaic Generation': 'Общая фотоэлектрическая генерация',
            'Total EV Charger Consumption': 'Общее потребление зарядных устройств EV',
            'Total Load Consumption': 'Общее потребление нагрузки',
            'Total Grid Buy': 'Общая покупка из сети',
            'Total Grid Sell': 'Общая продажа в сеть',
            'Total Efficiency': 'Общая эффективность',
            'Discharge Achievement Rate': 'Скорость достижения разряда',
            // Revenue Indicator
            "Today's Cost": "Today's Cost",
            "Today's Income": "Today's Income",
            "Total Cost": "Total Cost",
            "Total Income": "Total Income",
            "Today's Revenue": "Today's Revenue",
            
            'Revenue Ranking': 'Рейтинг доходов',
            'Efficiency Ranking': 'Рейтинг эффективности',
            'Charge Ranking': 'Рейтинг зарядной емкости',
            'Discharge Ranking': 'Рейтинг разряда',
            'Number of Microgrids': 'Количество микросетей',
            'Number of Power Stations': 'Количество электростанций',
            'Microgrid List': 'Список микросетей',
            'Select Microgrid': 'Выбрать микросеть',
            'Previous Page': 'Предыдущая страница',
            'Next Page': 'Следущая страница',
            '7 Days': '7 дней',
            'Charge UNIT': 'Заряжать {{UNIT}}',
            'Discharge UNIT': 'увольнять {{UNIT}}',
            'Generation UNIT': 'генерировать электричество {{UNIT}}',
            'Energy Indicator': 'Энергетика',
            'Revenue Indicator': 'Поступления',
            'Carbon Indicator': 'Углерод',

            // Energy Storage Power Station
            'Battery Operating State': 'режим работы батареи',
            'Battery State': 'Состояние батареи',
            'Battery Unknown': 'Неизвестный',
            'Battery Stopped': 'Прекращено',
            'Battery Reserved': 'Reserved', // 0
            'Battery Fault': 'Ошибка', // 1
            'Battery Warning': 'предупреждение', // 2
            'Battery Standby': 'Запасные материалы', // 3
            'Battery Prohibit DisCharging': 'Запрещается выгрузка', // 4
            'Battery Prohibit Charging': 'Зарядка запрещена.', // 5
            'Battery Normal': 'Типичный', // 6
            'Battery Charging': 'Заряжается.', // 7
            'Battery Discharging': 'В разряде.', // 8
            'Battery Idle': 'Idle', // 9
            'Phase of Lifecycle': 'Этапы жизненного цикла',
            'Use Phase': 'Этап использования',
            'Commissioning Phase': 'Этап отладки',
            'Commissioning Date': 'Commissioning Date',
            'Installation Phase': 'Этап установки',
            'Device Status': 'Состояние устройства',
            'Basic Information': 'Основная информация',
            'Gateway': 'Gateway',
            'Grid Meter': 'Grid Meter',
            'Load Meter': 'Load Meter',
            'ESS Meter': 'ESS Meter',
            'Total Active Power': 'Total Active Power',
            'Active Power A': 'Active Power A',
            'Active Power B': 'Active Power B',
            'Active Power C': 'Active Power C',
            'Total Reactive Power': 'Total Reactive Power',
            'Reactive Power A': 'Reactive Power A',
            'Reactive Power B': 'Reactive Power B',
            'Reactive Power C': 'Reactive Power C',
            'Total Apparent Power': 'Total Apparent Power',
            'Apparent Power A': 'Apparent Power A',
            'Apparent Power B': 'Apparent Power B',
            'Apparent Power C': 'Apparent Power C',
            'Total Power Factor': 'Total Power Factor',
            'Active Energy Import': 'Active Energy Import',
            'Active Energy Export': 'Active Energy Export',
            'Active Energy Net': 'Active Energy Net',

            'Generator': 'Generator',

            // Photovoltaic Power Station
            'Invertor': 'инверторы',
            'Invertor Run State': 'Режим работы',
            'Invertor Unknown': 'Неизвестный',
            'Invertor Initializing': 'Начинается',
            'Invertor Standby': 'Запасные материалы',
            'Invertor Shutdown': 'Остановка',
            'Invertor Fault': 'Ошибка',
            'Invertor Running': 'Бег',

            //Advanced Reporting & Knowledge base
            'Created Datetime': 'Дата и время создания',
            'File Format': 'Формат файла',
            'File Size': 'Размер файла',
            Uploader: 'Разместил(а)',
            //Error
            "The page you're looking for is not found": 'Страница, которую вы ищете, не найдена',
            "Make sure the address is correct and that the page hasn't moved. ":
                'Убедитесь, что адрес указан правильно и страница не перемещена. ',
            'If you think this is a mistake,': 'Если вы считаете, что это ошибка,',
            'contact us': 'Свяжитесь с нами',
            'Take me home': 'Отвези меня домой',
            'Whoops, something went wrong!': 'Ой, что-то пошло не так!',
            'Try refreshing the page, or going back and attempting the action again. ':
                'Попробуйте обновить страницу или вернуться и повторить попытку выполнения. ',
            'If this problem persists,': 'Если проблема не устранена,',
            'Captcha Error': 'Ошибка капчи',
            'Confirm Password Error': 'Пароль подтверждения не совпадает',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                'Похоже, вы нажали \
    по неверной ссылке для сброса пароля. Пожалуйста, попробуйте еще раз.',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                'Похоже, вы нажали \
    по неверной ссылке на регистрационный аккаунт. Пожалуйста, попробуйте еще раз.',
            //Tenant Bill
            'Lease Contract Number': 'Номер договора аренды',
            Download: 'Загружать',
            Print: 'Печатать',
            'Payment Notice': 'Уведомление об оплате',
            'Bill To': 'Билл К',
            'Bill Number': 'Номер счета',
            'Bill Date': 'Дата выставления счета',
            'Payment Due Date': 'Срок оплаты',
            'Amount Payable': 'Сумма к оплате',
            'Billing Period Start': 'Начало расчетного периода',
            'Billing Period End': 'Окончание расчетного периода',
            Quantity: 'Количество',
            Price: 'Цена',
            Unit: 'Единица',
            Amount: 'Количество',
            Subtotal: 'Промежуточная сумма',
            'VAT Output Tax': 'Налог на добавленную стоимость',
            'Total Amount Payable': 'Общая сумма к оплате',
            'Please make sure to pay on or before the payment due date above':
                'Пожалуйста, убедитесь, что вы оплатили в установленный выше срок оплаты или раньше',
            'Send money to the following account': 'Отправьте деньги на следующий счет',
            'Account Name': 'Имя учетной записи',
            'Bank Name': 'Название банка',
            'Bank Address': 'Адрес банка',
            'RMB Account': 'Счет в юанях',
            // button
            'Toggle Navigation': 'Переключить навигацию',
            // working calendar
            'Working Days': 'Будни',
            'Non Working Days': 'Нерабочие дни',
            'Select Row': 'Пожалуйста, выберите строку данных',
            // Offline Meter Input
            'Daily Value': 'Суточная норма',
            Date: 'Дата',
            'Successfully Saved': 'Успешно сохранено',
            'Previous Data Is Empty': 'Предыдущие данные пусты',
            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Administrator session not found',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Administrator session timeout',
            'API.ADVANCED_REPORT_NOT_FOUND': 'Advanced report not found',
            'API.API_KEY_HAS_EXPIRED': 'Key has expired',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
            'API.API_KEY_NOT_FOUND': 'Key not found',
            'API.BAD_REQUEST': 'Bad request',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
            'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Cannot set existing submeter as master meter',
            'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Combined equipment equipment relation exists',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Combined equipment equipment relation not found',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Combined equipment meter relation exists',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Combined equipment meter relation not found',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Combined equipment name is already in use',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Combined equipment not found',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Combined equipment offline meter relation exists',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Combined equipment offline meter relation not found',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Combined equipment parameter name is already in use',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Combined equipment parameter not found or not match',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Combined equipment virtual meter relation exists',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Combined equipment virtual meter relation not found',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
            'API.COMMAND_NOT_FOUND': 'Command not  found',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Contact name is already in use',
            'API.CONTACT_NOT_FOUND': 'Contact not found',
            'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Cost center external id exists',
            'API.COST_CENTER_NAME_EXISTS': 'Cost center name exists',
            'API.COST_CENTER_NOT_FOUND': 'Cost center not found',
            'API.COST_FILE_NOT_FOUND': 'Cost file not found',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Data source name is already in use',
            'API.DATA_SOURCE_NOT_FOUND': 'Data source not found',
            'API.DATABASE_ERROR': 'Database error',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Date Is Already In Working Calendar',
            'API.DATE_LOCAL_NOT_FOUND': 'Date local not found',
            'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Distribution circuit name is already in use',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Distribution circuit not found',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Distribution circuit point relation exists',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Distribution circuit point relation not found',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Distribution system name is already in use',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Distribution system not found',
            'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
            'API.EMAIL_IS_ALREADY_IN_USE': 'Email is already in use',
            'API.EMAIL_MESSAGE_NOT_FOUND': 'Email message not found',
            'API.EMAIL_NOT_FOUND': 'Email not found',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Email server host is already in use',
            'API.EMAIL_SERVER_NOT_FOUND': 'Email server not found',
            'API.EMPTY_VARIABLES_ARRAY': 'Empty variables array',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Energy category name is already in use',
            'API.ENERGY_CATEGORY_NOT_FOUND': 'Energy category not found',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energy category used in energy items',
            'API.ENERGY_CATEGORY_USED_IN_METER': 'Energy category used in meter',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energy category used in offline meter',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Energy category used in tariffs',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energy category used in virtual meter',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energy flow diagram link is already in use',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram link not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram node name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram node not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energy flow diagram not found',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item does not belong to energy category',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item is not belong to energy category',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Energy item name is already in use',
            'API.ENERGY_ITEM_NOT_FOUND': 'Energy item not found',
            'API.ENERGY_ITEM_USED_IN_METER': 'Energy item used in meter',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energy item used in offline meter',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energy item used in virtual meter',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
            'API.EQUIPMENT_METER_RELATION_EXISTS': 'Equipment meter relation exists',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Equipment meter relation not found',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Equipment name is already in use',
            'API.EQUIPMENT_NOT_FOUND': 'Equipment not found',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Equipment offline meter relation exists',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Equipment offline meter relation not found',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Equipment parameter name is already in use',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Equipment parameter not found or not match',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Equipment virtual meter relation exists',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Equipment virtual meter relation not found',
            'API.ERROR': 'Error',
            'API.EXCEPTION': 'Exception',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
            'API.FAILED_TO_RESTORE_COST_FILE': 'Failed to restore cost file',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Failed to restore knowledge file',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Failed to restore offline meter file',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Failed to save offline meter file',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
            'API.FAILED_TO_UPLOAD_COST_FILE': 'Failed to upload cost file',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Failed to upload knowledge file',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Failed to upload offline meter file',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway name is already in use',
            'API.GATEWAY_NOT_FOUND': 'Gateway not found',
            'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
            'API.INVALID_': 'Invalid ',
            'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
            'API.INVALID_ADDRESS': 'Invalid address',
            'API.INVALID_ADDRESS_VALUE': 'Invalid address value',
            'API.INVALID_ADVANCED_REPORT_ID': 'Invalid advanced report id',
            'API.INVALID_API_KEY_ID': 'Invalid api key id',
            'API.INVALID_API_KEY_NAME': 'Invalid api key name',
            'API.INVALID_AREA_VALUE': 'Invalid area value',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
            'API.INVALID_BASE_PERIOD_END_DATETIME': 'Invalid base period end datetime',
            'API.INVALID_BASE_PERIOD_START_DATETIME': 'Invalid base period start datetime',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
            'API.INVALID_BAUD_RATE': 'Invalid baud rate',
            'API.INVALID_BUILDINGS_VALUE': 'Invalid buildings value',
            'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
            'API.INVALID_CAPACITY': 'Invalid capacity',
            'API.INVALID_CATEGORY': 'Invalid category',
            'API.INVALID_CHANNEL': 'Invalid channel',
            'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
            'API.INVALID_COMBINED_EQUIPMENT_ID': 'Invalid combined equipment id',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Invalid combined equipment name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Invalid combined equipment parameter id',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Invalid combined equipment parameter name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Invalid combined equipment parameter type',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Invalid combined equipment uuid',
            'API.INVALID_COMMAND_ID': 'Invalid command id',
            'API.INVALID_COMMAND_NAME': 'Invalid command name',
            'API.INVALID_CONNECTION': 'Invalid connection',
            'API.INVALID_CONSTANT_VALUE': 'Invalid constant value',
            'API.INVALID_CONTACT_ID': 'Invalid contact id',
            'API.INVALID_CONTACT_NAME': 'Invalid contact name',
            'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
            'API.INVALID_COST_CENTER_ID': 'Invalid cost center id',
            'API.INVALID_COST_FILE_ID': 'Invalid cost file id',
            'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
            'API.INVALID_DATA_SOURCE_ID': 'Invalid data source id',
            'API.INVALID_DATA_SOURCE_NAME': 'Invalid data source name',
            'API.INVALID_DATA_SOURCE_PROTOCOL': 'Invalid data source protocol',
            'API.INVALID_DATE_LOCAL': 'Invalid date local',
            'API.INVALID_DENOMINATOR_METER_UUID': 'Invalid denominator meter uuid',
            'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
            'API.INVALID_DISPLAY_NAME': 'Invalid display name',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Invalid distribution circuit id',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Invalid distribution circuit name',
            'API.INVALID_DISTRIBUTION_ROOM': 'Invalid distribution room',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Invalid distribution system id',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Invalid distribution system name',
            'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
            'API.INVALID_EMAIL': 'Invalid email',
            'API.INVALID_EMAIL_MESSAGE_ID': 'Invalid email message id',
            'API.INVALID_EMAIL_SERVER_HOST': 'Invalid email server host',
            'API.INVALID_EMAIL_SERVER_ID': 'Invalid email server id',
            'API.INVALID_END_DATE_FORMAT': 'Invalid end date format',
            'API.INVALID_END_DATETIME': 'Invalid end datetime',
            'API.INVALID_ENERGY_CATEGORY_ID': 'Invalid energy category id',
            'API.INVALID_ENERGY_CATEGORY_NAME': 'Invalid energy category name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Invalid energy flow diagram id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Invalid energy flow diagram link id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Invalid energy flow diagram name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Invalid energy flow diagram node id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Invalid energy flow diagram node name',
            'API.INVALID_ENERGY_ITEM_ID': 'Invalid energy item id',
            'API.INVALID_ENERGY_ITEM_NAME': 'Invalid energy item name',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
            'API.INVALID_EQUATION_IN_EXPRESSION': 'Invalid equation in expression',
            'API.INVALID_EQUIPMENT_ID': 'Invalid equipment id',
            'API.INVALID_EQUIPMENT_NAME': 'Invalid equipment name',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Invalid equipment parameter id',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Invalid equipment parameter name',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Invalid equipment parameter type',
            'API.INVALID_EQUIPMENT_UUID': 'Invalid equipment uuid',
            'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
            'API.INVALID_EXPRESSION': 'Invalid expression',
            'API.INVALID_EXPRESSION_OBJECT': 'Invalid expression object',
            'API.INVALID_FDD_CODE': 'Invalid fdd code',
            'API.INVALID_FLOORS_VALUE': 'Invalid floors value',
            'API.INVALID_FROM_ADDR': 'Invalid from addr',
            'API.INVALID_GATEWAY_ID': 'Invalid gateway id',
            'API.INVALID_GATEWAY_NAME': 'Invalid gateway name',
            'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
            'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Invalid hourly high limit value',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Invalid hourly low limit value',
            'API.INVALID_Id': 'Invalid id',
            'API.INVALID_IS_ADMIN_VALUE': 'Invalid is admin value',
            'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
            'API.INVALID_IS_COUNTED_VALUE': 'Invalid is counted value',
            'API.INVALID_IS_ENABLED': 'Invalid is enabled',
            'API.INVALID_IS_HIDDEN': 'Invalid is hidden',
            'API.INVALID_IS_IN_LEASE_VALUE': 'Invalid is in lease value',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Invalid is input counted value',
            'API.INVALID_IS_KEY_TENANT_VALUE': 'Invalid is key tenant value',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Invalid is output counted value',
            'API.INVALID_IS_OUTPUT_VALUE': 'Invalid is output value',
            'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
            'API.INVALID_IS_TREND_VALUE': 'Invalid is trend value',
            'API.INVALID_IS_VIRTUAL_VALUE': 'Invalid is virtual value',
            'API.INVALID_KGCE': 'Invalid kgce',
            'API.INVALID_KGCO2E': 'Invalid kgco2e',
            'API.INVALID_KNOWLEDGE_FILE_ID': 'Invalid knowledge file id',
            'API.INVALID_LATITUDE_VALUE': 'Invalid latitude value',
            'API.INVALID_LEASE_NUMBER_VALUE': 'Invalid lease number value',
            'API.INVALID_LONGITUDE_VALUE': 'Invalid longitude value',
            'API.INVALID_LOW_LIMIT_VALUE': 'Invalid low limit value',
            'API.INVALID_MASTER_METER_ID': 'Invalid master meter id',
            'API.INVALID_MENU_ID': 'Invalid menu id',
            'API.INVALID_MESSAGE_DATA': 'Invalid message data',
            'API.INVALID_MESSAGE_TEMPLATE': 'Invalid message template',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
            'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
            'API.INVALID_METER_ID': 'Invalid meter id',
            'API.INVALID_METER_NAME': 'Invalid meter name',
            'API.INVALID_METER_UUID': 'Invalid meter uuid',
            'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
            'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
            'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
            'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
            'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
            'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
            'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
            'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
            'API.INVALID_NAME_VALUE': 'Invalid name value',
            'API.INVALID_NEW_PASSWORD': 'Invalid new password',
            'API.INVALID_NON_WORKING_DAY_ID': 'Invalid non working day ID',
            'API.INVALID_NOTIFICATION_ID': 'Invalid notification id',
            'API.INVALID_NUMERATOR_METER_UUID': 'Invalid numerator meter uuid',
            'API.INVALID_OBJECT_TYPE': 'Invalid object type',
            'API.INVALID_OFFLINE_METER_DATA': 'Invalid offline meter data',
            'API.INVALID_OFFLINE_METER_FILE_ID': 'Invalid offline meter file id',
            'API.INVALID_OFFLINE_METER_ID': 'Invalid offline meter id',
            'API.INVALID_OFFLINE_METER_NAME': 'Invalid offline meter name',
            'API.INVALID_OFFLINE_METER_UUID': 'Invalid offline meter uuid',
            'API.INVALID_OFFSET_CONSTANT_VALUE': 'Invalid offset constant value',
            'API.INVALID_OLD_PASSWORD': 'Invalid old password',
            'API.INVALID_OPENID': 'Invalid openid',
            'API.INVALID_PARENT_SPACE_ID': 'Invalid parent space id',
            'API.INVALID_PASSWORD': 'Invalid password',
            'API.INVALID_PAYLOAD': 'Invalid payload',
            'API.INVALID_PEAK_CURRENT': 'Invalid peak current',
            'API.INVALID_PEAK_LOAD': 'Invalid peak load',
            'API.INVALID_PERIOD_TYPE': 'Invalid period type',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
            'API.INVALID_POINT_ID': 'Invalid point id',
            'API.INVALID_POINT_NAME': 'Invalid point name',
            'API.INVALID_PORT': 'Invalid port',
            'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
            'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
            'API.INVALID_PRIORITY': 'Invalid priority',
            'API.INVALID_PRIVILEGE': 'Invalid privilege',
            'API.INVALID_PRIVILEGE_DATA': 'Invalid privilege data',
            'API.INVALID_PRIVILEGE_ID': 'Invalid privilege id',
            'API.INVALID_PRIVILEGE_NAME': 'Invalid privilege name',
            'API.INVALID_RATIO_VALUE': 'Invalid ratio value',
            'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
            'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
            'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
            'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
            'API.INVALID_REPLY': 'Invalid reply',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Invalid reporting period end datetime',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Invalid reporting period start datetime',
            'API.INVALID_REQUIRES_AUTHENTICATION': 'Invalid requires authentication',
            'API.INVALID_ROOMS_VALUE': 'Invalid rooms value',
            'API.INVALID_RULE_ID': 'Invalid rule id',
            'API.INVALID_RULE_NAME': 'Invalid rule name',
            'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
            'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
            'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
            'API.INVALID_SENSOR_ID': 'Invalid sensor id',
            'API.INVALID_SENSOR_NAME': 'Invalid sensor name',
            'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
            'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
            'API.INVALID_SERIAL_PORT': 'Invalid serial port',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Invalid session please re-login',
            'API.INVALID_SET_VALUE': 'Invalid set value',
            'API.INVALID_SHOPFLOOR_ID': 'Invalid shopfloor id',
            'API.INVALID_SHOPFLOOR_NAME': 'Invalid shopfloor name',
            'API.INVALID_SHOPFLOOR_UUID': 'Invalid shopfloor uuid',
            'API.INVALID_SOURCE_NODE_ID': 'Invalid source node id',
            'API.INVALID_SPACE_ID': 'Invalid space id',
            'API.INVALID_SPACE_NAME': 'Invalid space name',
            'API.INVALID_SPACE_UUID': 'Invalid space uuid',
            'API.INVALID_START_DATE_FORMAT': 'Invalid start date format',
            'API.INVALID_START_DATETIME': 'Invalid start datetime',
            'API.INVALID_STATUS': 'Invalid status',
            'API.INVALID_STORE_ID': 'Invalid store id',
            'API.INVALID_STORE_NAME': 'Invalid store name',
            'API.INVALID_STORE_TYPE_DESCRIPTION': 'Invalid store type description',
            'API.INVALID_STORE_TYPE_ID': 'Invalid store type id',
            'API.INVALID_STORE_TYPE_NAME': 'Invalid store type name',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Invalid store type simplified code',
            'API.INVALID_STORE_UUID': 'Invalid store uuid',
            'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
            'API.INVALID_SVG': 'Invalid SVG',
            'API.INVALID_SWITCHGEAR': 'Invalid switchgear',
            'API.INVALID_TARGET_NODE_ID': 'Invalid target node id',
            'API.INVALID_TARIFF_BLOCK_PRICING': 'Invalid tariff block pricing',
            'API.INVALID_TARIFF_ID': 'Invalid tariff id',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Invalid tariff time of use pricing',
            'API.INVALID_TARIFF_TYPE': 'Invalid tariff type',
            'API.INVALID_TENANT_ID': 'Invalid tenant id',
            'API.INVALID_TENANT_NAME': 'Invalid tenant name',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Invalid tenant type description',
            'API.INVALID_TENANT_TYPE_ID': 'Invalid tenant type id',
            'API.INVALID_TENANT_TYPE_NAME': 'Invalid tenant type name',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Invalid tenant type simplified code',
            'API.INVALID_TENANT_UUID': 'Invalid tenant uuid',
            'API.INVALID_TEXT_MESSAGE_ID': 'Invalid text message id',
            'API.INVALID_TIMEZONE_ID': 'Invalid timezone id',
            'API.INVALID_TOKEN': 'Invalid token',
            'API.INVALID_TOPIC': 'Invalid topic',
            'API.INVALID_UNIT_OF_MEASURE': 'Invalid unit of measure',
            'API.INVALID_UNIT_OF_PRICE': 'Invalid unit of price',
            'API.INVALID_UNITS': 'Invalid units',
            'API.INVALID_USER_ID': 'Invalid user id',
            'API.INVALID_USER_NAME': 'Invalid user name',
            'API.INVALID_USER_NAME_OR_EMAIL': 'Invalid user name or email',
            'API.INVALID_USER_PHONE': 'Invalid user phone',
            'API.INVALID_USER_PLEASE_RE_LOGIN': 'Invalid user please re-login',
            'API.INVALID_USER_UUID': 'Invalid user uuid',
            'API.INVALID_USERNAME': 'Invalid userName',
            'API.INVALID_VARIABLE_METER_ID': 'Invalid variable meter id',
            'API.INVALID_VARIABLE_METER_TYPE': 'Invalid variable meter type',
            'API.INVALID_VARIABLE_NAME': 'Invalid variable name',
            'API.INVALID_VERIFICATION_CODE': 'Invalid verification code',
            'API.INVALID_VIRTUAL_METER_ID': 'Invalid virtual meter id',
            'API.INVALID_VIRTUAL_METER_NAME': 'Invalid virtual meter name',
            'API.INVALID_VIRTUAL_METER_UUID': 'Invalid virtual meter uuid',
            'API.INVALID_WEB_MESSAGE_ID': 'Invalid web message id',
            'API.INVALID_WECHAT_MESSAGE_ID': 'Invalid wechat message id',
            'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
            'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
            'API.INVALID_WORKING_CALENDAR_ID': 'Invalid working calendar id ',
            'API.INVALID_WORKING_CALENDAR_NAME': 'Invalid working calendar name',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Knowledge File Cannot be Removed from Disk',
            'API.KNOWLEDGE_FILE_NOT_FOUND': 'Knowledge file not found',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY':
                'Master meter does not belong to same energy category',
            'API.MASTER_METER_NOT_FOUND': 'Master meter not found',
            'API.MENU_NOT_FOUND': 'Menu not found',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
            'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
            'API.METER_NAME_IS_ALREADY_IN_USE': 'Meter name is already in use',
            'API.METER_NOT_FOUND': 'Meter not found',
            'API.METER_OF_VARIABLE_NOT_FOUND': 'Meter of variable not found',
            'API.METER_POINT_RELATION_EXISTS': 'Meter point relation exists',
            'API.METER_POINT_RELATION_NOT_FOUND': 'Meter point relation not found',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
            'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
            'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
            'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
                'Microgrid power conversion system name is already in use',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
            'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
            'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'New password length cannot exceed 100 characters',
            'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
            'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
            'API.NON_WORKING_DAY_NOT_FOUND': 'Non working day non found',
            'API.NOT_FOUND': 'Not found',
            'API.NOTIFICATION_NOT_FOUND': 'Notification not found',
            'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline meter file not found',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Offline meter name is already in use',
            'API.OFFLINE_METER_NOT_FOUND': 'Offline meter not found',
            'API.INVALID_OFFLINE_METER_VALUE': 'Недействительное значение автономного счетчика',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline meter of variable not found',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Old password length cannot exceed 100 characters',
            'API.PARENT_SPACE_NOT_FOUND': 'Parent space not found',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Password length cannot exceed 100 characters',
            'API.PASSWORDS_MATCH': 'New password is the same as the old password',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
            'API.POINT_NAME_IS_ALREADY_IN_USE': 'Point name is already in use',
            'API.POINT_NOT_FOUND': 'Point not found',
            'API.POWER_POINT_NOT_FOUND': 'Power point not found',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Privilege name is already in use',
            'API.PRIVILEGE_NOT_FOUND': 'Privilege not found',
            'API.RULE_NAME_IS_ALREADY_IN_USE': 'Rule name is already in use',
            'API.RULE_NOT_FOUND': 'Rule not found',
            'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensor name is already in use',
            'API.SENSOR_NOT_FOUND': 'Sensor not found',
            'API.SENSOR_POINT_RELATION_EXISTS': 'Sensor point relation exists',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Sensor point relation not found',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Shopfloor equipment relation exists',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Shopfloor equipment relation not found',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Shopfloor meter relation exists',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Shopfloor meter relation not found',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Shopfloor name is already in use',
            'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor not found',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Shopfloor offline meter relation exists',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Shopfloor offline meter relation not found',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Shopfloor point relation exists',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Shopfloor point relation not found',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Shopfloor sensor relation exists',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Shopfloor sensor relation not found',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Shopfloor virtual meter relation exists',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Shopfloor virtual meter relation not found',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Shopfloor working calendar relation exists',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Shopfloor working calendar relation not found',
            'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
            'API.SOURCE_NODE_NOT_FOUND': 'Source node not found',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Space combined equipment relation exists',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Space combined equipment relation not found',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Space equipment relation exists',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Space equipment relation not found',
            'API.SPACE_METER_RELATION_EXISTS': 'Space meter relation exists',
            'API.SPACE_METER_RELATION_NOT_FOUND': 'Space meter relation not found',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Space name is already in use',
            'API.SPACE_NOT_FOUND': 'Space not found',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Space not found in privilege',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Space offline meter relation exists',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Space offline meter relation not found',
            'API.SPACE_POINT_RELATION_EXISTS': 'Space point relation exists',
            'API.SPACE_POINT_RELATION_NOT_FOUND': 'Space point relation not found',
            'API.SPACE_SENSOR_RELATION_EXISTS': 'Space sensor relation exists',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Space sensor relation not found',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Space shopfloor relation exists',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Space shopfloor relation not found',
            'API.SPACE_STORE_RELATION_EXISTS': 'Space store relation exists',
            'API.SPACE_STORE_RELATION_NOT_FOUND': 'Space store relation not found',
            'API.SPACE_TENANT_RELATION_EXISTS': 'Space tenant relation exists',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Space tenant relation not found',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Space virtual meter relation exists',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Space virtual meter relation not found',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Space working calendar relation exists',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Space working calendar relation not found',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Start datetime must be early than end datetime',
            'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
            'API.STORE_METER_RELATION_EXISTS': 'Store meter relation exists',
            'API.STORE_METER_RELATION_NOT_FOUND': 'Store meter relation not found',
            'API.STORE_NAME_IS_ALREADY_IN_USE': 'Store name is already in use',
            'API.STORE_NOT_FOUND': 'Store not found',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Store offline meter relation exists',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Store offline meter relation not found',
            'API.STORE_POINT_RELATION_EXISTS': 'Store point relation exists',
            'API.STORE_POINT_RELATION_NOT_FOUND': 'Store point relation not found',
            'API.STORE_SENSOR_RELATION_EXISTS': 'Store sensor relation exists',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Store sensor relation not found',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Store type name is already in use',
            'API.STORE_TYPE_NOT_FOUND': 'Store type not found',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Store type simplified code is already in use',
            'API.STORE_TYPE_USED_IN_STORE': 'Store type used in store',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Store virtual meter relation exists',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Store virtual meter relation not found',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Store working calendar relation exists',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Store working calendar relation not found',
            'API.TARGET_NODE_NOT_FOUND': 'Target node not found',
            'API.TARIFF_IN_USE': 'Tariff in use',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tariff is already associated with cost center',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tariff is not associated with cost center',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tariff name is already in use',
            'API.TARIFF_NOT_FOUND': 'Tariff not found',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
            'API.TENANT_METER_RELATION_EXISTS': 'Tenant meter relation exists',
            'API.TENANT_METER_RELATION_NOT_FOUND': 'Tenant meter relation not found',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Tenant name is already in use',
            'API.TENANT_NOT_FOUND': 'Tenant not found',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Tenant offline meter relation exists',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Tenant offline meter relation not found',
            'API.TENANT_POINT_RELATION_EXISTS': 'Tenant point relation exists',
            'API.TENANT_POINT_RELATION_NOT_FOUND': 'Tenant point relation not found',
            'API.TENANT_SENSOR_RELATION_EXISTS': 'Tenant sensor relation exists',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Tenant sensor relation not found',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Tenant type name is already in use',
            'API.TENANT_TYPE_NOT_FOUND': 'Tenant type not found',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Tenant type simplified code is already in use',
            'API.TENANT_TYPE_USED_IN_TENANT': 'Tenant type used in tenant',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Tenant virtual meter relation exists',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Tenant virtual meter relation not found',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Tenant working calendar relation exists',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Tenant working calendar relation not found',
            'API.TEXT_MESSAGE_NOT_FOUND': 'Text message not found',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'The reporting period must be longer than 15 minutes',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'There is relation with child meters',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'There is relation with children spaces',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS':
                'There is relation with combined equipment parameters',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'There is relation with combined equipments',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'There is relation with data sources',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'There is relation with energy flow diagram links',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'There Is Relation With Energy Storage Containers Batteries',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'There Is Relation With Energy Storage Containers Grids',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'There Is Relation With Energy Storage Containers Loads',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'There Is Relation With Energy Storage Containers Power Conversion Systems',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'There is relation with equipment parameters',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'There is relation with equipments',
            'API.THERE_IS_RELATION_WITH_METER': 'There is relation with meter',
            'API.THERE_IS_RELATION_WITH_METERS': 'There is relation with meters',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'There is relation with offline meter',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'There is relation with offline meters',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'There is relation with other virtual meters',
            'API.THERE_IS_RELATION_WITH_SENSORS': 'There is relation with sensors',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'There is relation with shopfloors',
            'API.THERE_IS_RELATION_WITH_SPACES': 'There is relation with spaces',
            'API.THERE_IS_RELATION_WITH_STORES': 'There is relation with stores',
            'API.THERE_IS_RELATION_WITH_TENANTS': 'There is relation with tenants',
            'API.THERE_IS_RELATION_WITH_USERS': 'There is relation with users',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'There is relation with virtual meter',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Это связано с виртуальной электростанцией.',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'This data source is being used by a meter',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This meter is being used by a virtual meter',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This offline meter is being used by a virtual meter',
            'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
            'API.THIS_SPACE_CANNOT_BE_DELETED': 'This space cannot be deleted',
            'API.TIMEZONE_NOT_FOUND': 'Timezone not found',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token not found in headers please login',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'User Account Has Been Locked',
            'API.USER_ACCOUNT_HAS_EXPIRED': 'User Account Has Expired',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
            'API.USER_NAME_IS_ALREADY_IN_USE': 'User name is already in use',
            'API.USER_NOT_FOUND': 'User not found',
            'API.USER_PASSWORD_HAS_EXPIRED': 'User Password Has Expired',
            'API.USER_PRIVILEGE_NOT_FOUND': 'User privilege not found',
            'API.USER_SESSION_NOT_FOUND': 'User session not found',
            'API.USER_SESSION_TIMEOUT': 'User session timeout',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'User uuid not found in headers please login',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Virtual meter name is already in use',
            'API.VIRTUAL_METER_NOT_FOUND': 'Virtual meter not found',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Virtual meter of variable not found',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtual point should be analog value',
            'API.WEB_MESSAGE_NOT_FOUND': 'Web message not found',
            'API.WECHAT_MESSAGE_NOT_FOUND': 'Wechat message not found',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
            'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Working calendar name is already in use',
            'API.WORKING_CALENDAR_NOT_FOUND': 'Working calendar not found',

            MasterMeter: 'Резюме таблиці',
            SubMeter: 'Підтаблиця',
            'Power Quality': 'جودة الطاقة',
            'About Power Quality': 'حول جودة الطاقة',
            Category: 'الفئة',
            Type: 'النوع',
            Limit: 'الحد',
            'Normal Limit': 'الحد العادي',
            'Severe Limit': 'الحد الحاد',
            Compliance: 'معدل الامتثال',
            'Worst Deviation': 'أسوأ انحراف',
            'Worst Time': 'وقت أسوأ انحراف',
            'Severe Exceed Count': 'عدد التجاوزات الحادة',
            'Worst Unbalance': 'أقصى عدم توازن',
            Hz: 'هرتز',
            voltage: 'الجهد',
            current: 'التيار',
            frequency: 'التردد',
            voltage_deviation: 'انحراف الجهد',
            current_unbalance: 'عدم توازن التيار',
            voltage_unbalance: 'عدم توازن الجهد',
            mean_deviation_pct: 'متوسط الانحراف (%)',
            p95_abs_deviation_pct: 'انحراف مطلق P95 (%)',
            mean_abs_deviation_hz: 'متوسط الانحراف المطلق (هرتز)',
            frequency_deviation: 'انحراف التردد',
            p95_abs_deviation_hz: 'انحراف مطلق P95 (هرتز)',
            mean_unbalance_pct: 'متوسط عدم التوازن (%)',
            p95_unbalance_pct: 'عدم التوازن P95 (%)',
            count: 'العدد',
            min: 'الحد الأدنى',
            max: 'الحد الأقصى',
            mean: 'المتوسط',
            std: 'الانحراف المعياري',
            p5: 'P5',
            p95: 'P95'
        }
};
